import {
    AssignmentInd,
    AssignmentInd as AssignmentIndIcon,
    DoNotDisturb as DoNotDisturbIcon,
    FileDownloadDone as FileDownloadDoneIcon,
    History as HistoryIcon,
    Search as SearchIcon,
    Security,
    Videocam,
} from "@mui/icons-material";
import ArticleIcon from '@mui/icons-material/Article';
import PieChartIcon from "@mui/icons-material/PieChart";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { Card, CardContent } from "@mui/material";

import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { ContainerScreenGeneral } from "../../../components";
import { UserContext } from "../../../context";
import { useWindowSize } from "../../../hooks";

const MenuNotificador = () => {

    const { actions } = useContext(UserContext);
    const size = useWindowSize();
    const { width } = size;

    const nav = useNavigate();

    const menuOptions = [
        {
            title: "A Repartir",
            description: "Actas listas para el reparto",
            path: "reparto",
            roles: ['notificador'],
            icon: <LocalShippingIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Notificadas",
            description: "Actas notificadas correctamente",
            path: "notificadas",
            roles: ['notificador'],
            icon: <TaskAltIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Sin Entregar",
            description: "Actas que no se pudieron entregar",
            path: "sin-entregar",
            roles: ['notificador'],
            icon: <ErrorOutlineIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
    ];

    return (
        <section>
            <ContainerScreenGeneral size={'lg'}>
                {/* <section className="flex flex-col items-center mt-10 "> */}
                <section className="d-flex flex-column align-items-center " style={{ marginTop: "2rem" }}>
                    {/* <h2 className="mb-4 pt-6 font-bold text-[1.5rem]">Trámites de Patente</h2> */}
                    <h1 className="fs-4">Notificador</h1>
                    {/* <p className="text-center fw-light fs-6 py-3">
                        Interfaz del notificador
                    </p> */}
                </section>
                <div
                    className={` d-flex flex-wrap mx-auto justify-content-center w-100 mt-5  ${width >= 640 ? "" : "flex-column"} `}
                    style={{ maxWidth: "1050px" }}
                >
                    {menuOptions.map((opc) => {
                        if (
                            opc.roles.some((role) =>
                                actions.user().roles?.some((userRole) => userRole.name == role)
                            ) ||
                            opc.roles.length == 0
                        ) {
                            return (
                                <section key={opc.title} className={`m-0  ${width < 640 ? "row p-3 " : width < 992 ? "row p-0" : "row p-3"} `} >
                                    <Card key={opc.title} className={` rounded d-flex flex-column align-items-center p-2 py-3 shadow`} >
                                        {opc.icon}
                                        <h5 className=" fw-bold m-0 pt-3 " style={{ fontSize: "20px", color: "#133040" }}>
                                            {opc.title}
                                        </h5>
                                        <CardContent className="pt-2">
                                            <p className="text-gray-600 text-center " style={{ fontSize: "16px", width: "180px", color: "#4B5563" }}>
                                                {opc.description}
                                            </p>

                                            <Button size="sm" className="mt-3 w-100  " style={{ backgroundColor: "#127AE2", border: "2px solid #127ae2" }} onClick={() => nav(opc.path)}>
                                                Ir a {opc.title}
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </section>
                            );
                        }
                    })}
                </div>
            </ContainerScreenGeneral>
        </section>
    )
}

export default MenuNotificador;